import { render } from "./Default.vue?vue&type=template&id=7b166aea"
import script from "./Default.vue?vue&type=script&lang=js"
export * from "./Default.vue?vue&type=script&lang=js"
script.render = render

export default script